export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Willkommensbonus"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Versuch dein Glück!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Du hast gewonnen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drehe das Rad und erhalte Testgelder, um alle Plattformfunktionen zu erkunden."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diese Gelder sind für Tests."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tauche ein und erlebe alle Funktionen."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drehen"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einlösen"])}
}